import { riskLevelMap, type RiskLevel } from '@/mocks/incidents';

export default function RiskBadge({
  level,
  size = 'md',
}: {
  level: RiskLevel;
  size?: 'sm' | 'md';
}) {
  const config = riskLevelMap[level];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${config.className} ${
        size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'
      }`}
    >
      <span className="flex h-3 w-3 items-center justify-center">
        <i className="ri-alert-line text-[11px]"></i>
      </span>
      {config.label}
    </span>
  );
}